import Swal from "sweetalert2";
import { IObrigacaoAcessorias } from "../interfaces/IObrigacaoAcessorias";
import api from "./Api";

class ObrigacaoAcessoriasService {
    async obterTodos(funcaoSucesso?: (data: IObrigacaoAcessorias[]) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.get<IObrigacaoAcessorias[]>('ObrigacaoAcessoria');
    
            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async criar(obrigacao: IObrigacaoAcessorias, funcaoSucesso?: (data: IObrigacaoAcessorias) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.post('ObrigacaoAcessoria', obrigacao);
    
            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async atualizar(obrigacao: IObrigacaoAcessorias, funcaoSucesso?: (data: IObrigacaoAcessorias) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.put(`ObrigacaoAcessoria/${obrigacao.id}`, obrigacao);
    
            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async excluir(id: number, funcaoSucesso?: () => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            await api.delete(`ObrigacaoAcessoria/${id}`);
    
            funcaoSucesso && funcaoSucesso();
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }
}

export default new ObrigacaoAcessoriasService();